import { DatePipe } from '@angular/common'
import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

import { SubcontractorTrainingTrackingRow } from '../../shared'

@Component({
    templateUrl: './tracking-details-modal.component.html',
    standalone: true,
    imports: [DatePipe],
})
export class TrackingDetailsModalComponent {
    @Input() row!: SubcontractorTrainingTrackingRow

    constructor(public activeModal: NgbActiveModal) {}

    get participantName() {
        const employeeName = `${this.row.participantFirstName ?? ''} ${this.row.participantLastName ?? ''}`.trim()
        if (employeeName) {
            return employeeName
        }
        const contactName = `${this.row.firstName ?? ''} ${this.row.lastName ?? ''}`.trim()
        return contactName || '(not started)'
    }
}
